// src/services/SlugService.js
import api from './Api';

const BASE_URL = 'slugs/';

export default {
  getAll: () => {
    return api.get(BASE_URL);
  },
  import: () => {
    return api.get(`${BASE_URL}import`);
  }
};